import clsx from 'clsx'

import { useNaturalPowerContext } from '../NaturalPowerCalculatorProvider'
import { useStepSlider } from './Context'

interface MaxLabelProps {
  className?: string
  children?: preact.ComponentChildren
}

export function MaxLabel({ children, className }: MaxLabelProps) {
  const services = useNaturalPowerContext()
  const [naturalPowerRatio, setNaturalPowerRatio] = services.naturalPower
  const { steps } = useStepSlider()
  const step = naturalPowerRatio * steps

  if (!children) {
    return null
  }

  const handleClick = () => {
    setNaturalPowerRatio(1)
    services.costInput.send('Update inputs', { naturalPowerRatio: 1 })
  }

  const showLabel = step < 3
  const showTarget = step <= 3

  return (
    <div
      onClick={handleClick}
      className={clsx(
        "relative shrink-0 place-self-end z-0 flex -mt-[14.5px] right-0 border-b border-r pointer-events-none border-mint rounded-br w-8 sm:w-4 md:w-16 h-10 md:h-12 lg:h-12 before:animate-pulse before:transition-all sm:before:duration-300 before:scale-0 before:opacity-0 md:before:opacity-100 before:content-[''] before:block before:w-10 before:h-10 before:bg-white/20 before:absolute before:top-0 before:-right-px before:rounded-full before:translate-x-1/2 before:-translate-y-1/2 before:pointer-events-auto before:cursor-pointer after:w-2.5 after:h-2.5 after:bg-mint after:absolute after:-top-0 after:-right-px after:rounded-full after:translate-x-1/2 after:-translate-y-1/2 after:pointer-events-auto after:cursor-pointer transition-all duration-300",
        className,
        showLabel ? 'border-mint/100' : 'border-mint/0',
        showTarget && 'md:before:scale-100 md:before:delay-200',
      )}>
      <button
        onClick={handleClick}
        className={clsx(
          'pointer-events-auto border-none place-self-end text-mint uppercase font-bold text-sm sm:text-xs md:text-sm whitespace-nowrap -translate-x-full -bottom-px translate-y-1/2 pr-2 transition-opacity duration-300',
          className,
          showLabel ? 'opacity-100' : 'opacity-0 pointer-events-none',
        )}>
        {children}
      </button>
    </div>
  )
}
